import api from "../axiosConfig";

export const getExercises = async ({
  from,
  to,
}: {
  from: string;
  to: string;
}) => {
  try {
    const response = await api.get("/my-plans", {
      params: { from, to },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching exercises:", error);
    throw error;
  }
};

export const GET_SIGNED_URL = "/storage/signed-url";

export const submitExercise = async ({
  planId,
  videoUrl,
  startTime,
  endTime,
}: {
  planId: string;
  videoUrl: Array<string> | string;
  startTime?: string;
  endTime?: string;
}) => {
  try {
    const response = await api.post("/submit-exercise", {
      planId,
      videoUrl,
      startTime,
      endTime,
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting exercise:", error);
    throw error;
  }
};
